import { Button, Dropdown } from 'semantic-ui-react';
import { MODE } from '../../constants';
import { ModeType } from '../../types';

type PagesModeControlsPropsType = {
    mode: ModeType;
    setMode: (mode: ModeType) => void;
    className?: string;
};

const PagesModeControls = ({ mode, setMode, className = '' }: PagesModeControlsPropsType) => {
    return (
        <div className={className}>
            <Button>Mode</Button>
            <Dropdown
                selection
                onChange={(__, d) => setMode(d.value as ModeType)}
                value={mode}
                options={Object.values(MODE).map((v) => {
                    return { key: v, text: v, value: v };
                })}
            />
        </div>
    );
};

export default PagesModeControls;
